import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-row mt-3" }
const _hoisted_3 = { class: "code-box code-box--with-border" }
const _hoisted_4 = {
  class: "text color--info",
  ref: "installationPath"
}
const _hoisted_5 = { class: "d-flex flex-row mt-3" }
const _hoisted_6 = { class: "code-box code-box--with-border" }
const _hoisted_7 = {
  class: "text color--info",
  ref: "permission"
}
const _hoisted_8 = { class: "d-flex flex-row mt-3" }
const _hoisted_9 = { class: "code-box code-box--with-border" }
const _hoisted_10 = {
  class: "text color--info",
  ref: "changePermission"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"text mt-4\">Utilize o PowerShell para a execução dos comandos e instale o OpenSSL.</div><div class=\"h6 mt-4\"><strong>Instalar OpenSSL</strong></div><div class=\"text mt-4\">Uma das opções é usar o OpenSSL distribuído com o pacote Git para Windows, disponível neste link:<a class=\"color--info\" href=\"https://git-scm.com/download/win\" target=\"_blank\">https://git-scm.com/download/win</a></div><div class=\"text mt-4\">Faça o download da versão <strong>Portable (&quot;thumbdrive edition&quot;)</strong> e descompacte na pasta desejada.</div><div class=\"text mt-4\">Acrescente o caminho completo para o executável toda vez que executar o OpenSSL. Exemplo:</div>", 5)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _cache[6] || (_cache[6] = [
          _createElementVNode("span", { class: "fw-bold" }, "$ c:\\users\\<usuario>\\git\\usr\\bin", -1),
          _createTextVNode("\\openssl req -new -newkey rsa:2048 -keyout "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.key", -1),
          _createTextVNode(" -out "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.csr", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-installation-path",
        name: "copy",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doCopy(this.$refs.installationPath, 1))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetContent(1))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"h6 mt-4\"><strong>Scripts PowerShell</strong></div><div class=\"text mt-4\">Serão necessários dois scripts, um para converter de hexadecimal para binário, e outro para codificar em Base64 a assinatura.</div><div class=\"text mt-4\">Crie o arquivo <span class=\"color--info\">hex-to-bin.ps1</span> com o seguinte (no Bloco de Notas ou outroeditor similar):</div><div class=\"code-box mt-3\"><div class=\"text\">$dir = (Get-Item .).FullName<br>$hex = Get-Content -Path &quot;$dir\\digitalterm_hash.hex&quot; -Raw<br> [byte[]]$bytes = ($hex -split &#39;(.{2})&#39; -ne &#39;&#39; -replace &#39;^&#39;, &#39;0X&#39;)<br> [System.IO.File]::WriteAllBytes(&quot;$dir\\digitalterm_hash.bin&quot;, $bytes)</div></div><div class=\"text mt-4\">Crie o arquivo <span class=\"color--info\">base64.ps1</span> com o seguinte conteúdo:</div><div class=\"code-box mt-3\"><div class=\"text\">$dir = (Get-Item .).FullName<br>$Text = Get-Content -Path &quot;$dir\\signature.bin&quot; -Raw<br> $Bytes = [System.Text.Encoding]::Unicode.GetBytes($Text)<br> $EncodedText =[Convert]::ToBase64String($Bytes)<br> $EncodedText</div></div><div class=\"h6 mt-4\"><strong>Permissões</strong></div><div class=\"text mt-4\">Para permitir a execução dos scripts, execute o comando e reponda Sim / Yes quando solicitado:</div>", 8)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, "$ Set-ExecutionPolicy -ExecutionPolicy Unrestricted -Scope CurrentUser", 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-permission",
        name: "copy",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCopy(this.$refs.permission, 2))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetContent(2))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "code-box mt-3" }, [
      _createElementVNode("div", { class: "text" }, [
        _createTextVNode("Execution Policy Change"),
        _createElementVNode("br"),
        _createTextVNode("The execution policy helps protect you from scripts that you do not trust. Changing the execution policy might expose"),
        _createElementVNode("br"),
        _createTextVNode(" you to the security risks described in the about_Execution_Policies help topic at"),
        _createElementVNode("br"),
        _createTextVNode(" https:/go.microsoft.com/fwlink/?LinkID=135170. Do you want to change the execution policy?"),
        _createElementVNode("br"),
        _createTextVNode(" [Y] Yes [A] Yes to All [N] No [L] No to All [S] Suspend [?] Help (default is \"N\"):"),
        _createElementVNode("span", { class: "red-background" }, "  Y ")
      ])
    ], -1)),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text mt-4" }, "Após a emissão do certificado, se desejar pode mudar novamente a política para não permitir a execução de scripts com o seguinte comando:", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, "$ Set-ExecutionPolicy -ExecutionPolicy Restricted -Scope CurrentUser", 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-change-permission",
        name: "copy",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doCopy(this.$refs.changePermission, 3))),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetContent(3))),
        style: {"cursor":"pointer"}
      })
    ])
  ]))
}